import './CountDown.css';
import properties from '../properties.json';
import {useScroll} from 'motion/react';
import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { CountDown } from './CountDown';
import { GiHamburgerMenu } from "react-icons/gi";
import { CgRing } from "react-icons/cg";
const drawerWidth = 240;


const pages = ['Itinerario', 'Confirmar Asistencia', 'Album', 'Regalos', 'Cronologia','Save the Date'];

export function NavBar(eventDate) { //eventDate example -> 'Feb 6, 2027 18:30:00'
  const ref = React.useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"]
  });

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{fontWeight: '500','font-family': "Parisienne", color:'#778C43', my: 2 }}>
        <CgRing color={properties.backgroudPrimaryColor}/> Boda Fer & Jaime
      </Typography>
      <Divider sx={{ borderBottomWidth: 2, borderColor:'#778C43'}}/>
      <List>
        {pages.map((page) => (
          <ListItem key={page} disablePadding>
            <ListItemButton sx={{color:properties.detailsColor, textAlign: 'center' }}>
              <ListItemText  primary={page} onClick={() => document.getElementById('section'+page)?.scrollIntoView({ behavior: 'smooth' })} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return <div className="countdown-timer">
    <Container maxWidth="xl">
      <Toolbar>
        <Typography
          variant="h5"
          noWrap
          component="a"
          sx={{
            mr: 2,
            display: { xs: 'none', md: 'flex' },
            textDecoration: 'none'
          }}
        >
          {CountDown(eventDate)}
        </Typography>

        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleDrawerToggle}
          >
            <GiHamburgerMenu color="white" />
          </IconButton>

        </Box>
        <Typography
          variant="h5"
          noWrap
          component="a"
          sx={{
            mr: 2,
            display: { xs: 'flex', md: 'none' },
            flexGrow: 1,
            textDecoration: 'none'
          }}
        >
          {CountDown(eventDate)}
        </Typography>
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-end' }}>
          {pages.map((page) => (
            <Button
              key={page}
              sx={{ my: 2, color: 'white', display: 'block' }}
              onClick={() => document.getElementById('section'+page)?.scrollIntoView({ behavior: 'smooth' })}
            >
              {page}
            </Button>
          ))}
        </Box>
      </Toolbar>
      <nav>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Container>
  </div>
}

